import APIService from '@/services/APIService.js';

export default {
  getAll(expirados = false) {
    return APIService.apiCall().get(`/saneamentosRazao/getAll?expirados=${expirados}`);
  },
  novo() {
    return APIService.apiCall().get('/saneamentosRazao/novo');
  },
  novos() {
    return APIService.apiCall().post('/saneamentosRazao/novos');
  },
  baixarArquivos(id, config = {}) {
    return APIService.apiCall().get(`/saneamentosRazao/baixarArquivos/${id}`, { responseType: 'blob', ...config });
  },
  baixarLogsTecnicos(id, config = {}) {
    return APIService.apiCall().get(`/saneamentosRazao/baixarLogs/${id}`, { responseType: 'blob', ...config });
  },
  listarArquivos(id) {
    return APIService.apiCall().get(`/saneamentosRazao/listarArquivos/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/saneamentosRazao/executar/${id}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/saneamentosRazao/excluir/${id}`);
  },
  duplicar(id) {
    return APIService.apiCall().post(`/saneamentosRazao/duplicar/${id}`);
  },
  getDadosPainel(id) {
    return APIService.apiCall().get(`/saneamentosRazao/getDadosPainel/${id}`);
  },
  baixarArquivoComparativo(id, config = {}) {
    return APIService.apiCall().get(`/saneamentosRazao/baixarArquivoComparativo/${id}`, { responseType: 'blob', ...config });
  },
  baixarArquivoAjusteManual(id, config = {}) {
    return APIService.apiCall().get(`/saneamentosRazao/baixarArquivoAjusteManual/${id}`, { responseType: 'blob', ...config });
  },
  listarAjustesManuais(id) {
    return APIService.apiCall().get(`/saneamentosRazao/listarAjustesManuais/${id}`);
  }
};
